import { colors } from '@lmc/common/constants'

export const getTextFill = (value) => {
  return value === 0 ? colors.darkgrey : colors.black
}

export const getIconFill = (value, normalColor) => {
  return value === 0 ? colors.grey : normalColor
}
